import React, { useState, useEffect} from 'react';
import { Space } from 'antd';
import { DatePicker } from "@life-line-lab/components-react";


type Date = {
  date: any;
  dateString: string;
}

type Value = {
  startDate: Date,
  endDate: Date
}

export interface DateRangeV2Props {
  startLabel?: string;
  endLabel?: string;
  isRequired?: boolean;
  isReadonly?: boolean;
  disableStartDate?:Date;
  disableEndDate?:Date;
  isError?: boolean;
  value?: Value;
  onChange?: (startDate: Date, endDate: Date) => void,
}

export const DateRangeV2: React.FC<DateRangeV2Props> = ({
  startLabel,
  endLabel,
  isRequired,
  isReadonly,
  isError,
  value,
  disableStartDate,
  disableEndDate,
  onChange,
}) => {

  const initialDate = { date: null, dateString: '' }
  const initialDateRange = { startDate: initialDate, endDate: initialDate }

  const [selectedDateRange, setSelectedDateRange] = useState<Value>(initialDateRange);

  const handleChange = (date: any, dateString: string, name: string) => {
    setSelectedDateRange({
      ...selectedDateRange,
      [name]: { date, dateString }
    });

    let startDate = initialDate, endDate = initialDate;
    if (name === 'startDate')
      startDate = { date, dateString }

    if (name === 'endDate')
    endDate = { date, dateString }

    onChange(startDate, endDate)
  }


  return (
    <div className="timepicker-range">
      <Space direction="horizontal" size="small">
        <DatePicker
          label={startLabel}
          name="startDate"
          isRequired={isRequired}
          isReadonly={isReadonly}
          isError={isError}
          //Note: target is in between these two dates will give it true, making the available range disabled, 
          //thus I put the '!' in front of it, the make everything outside that range disabled
          disabledDate={(target)=>!(target.isBetween(disableStartDate, disableEndDate))}
          value={value && value.startDate ? value.startDate.date : selectedDateRange.startDate.date}
          onChange={(date: any, dateString: string) => handleChange(date, dateString, 'startDate')}
        />

        <DatePicker
          label={endLabel}
          name="endDate"
          isRequired={isRequired}
          isReadonly={isReadonly}
          isError={isError}
          //Note: target is in between these two dates will give it true, making the available range disabled, 
          //thus I put the '!' in front of it, the make everything outside that range disabled
          disabledDate={(target)=>!(target.isBetween(disableStartDate, disableEndDate))}
          value={value && value.endDate ? value.endDate.date : selectedDateRange.endDate.date}
          onChange={(date: any, dateString: string) => handleChange(date, dateString, 'endDate')}
        />
      </Space>
    </div>
  )
}

export default DateRangeV2
